import { useMemo } from 'react';
import { useUserCountryCode } from 'selectors/user';

const US_LINK = 'https://bit.ly/sluvsunbum';

export const useSunbumUrl = (): string => {
  const countryCodeRaw = useUserCountryCode();

  const link = useMemo(() => {
    const countryCode = (countryCodeRaw || '').toString().trim().toUpperCase();

    switch (countryCode) {
      case 'CA':
        return 'https://bit.ly/sunbumca';
      case 'AU':
        return 'https://bit.ly/sunbumau';
      case 'GB':
      case 'UK':
        return 'https://bit.ly/sunbumuk';
      default:
        return US_LINK;
    }
  }, [countryCodeRaw]);

  return link;
};

export default useSunbumUrl;
